import { useState } from 'react';
import styled from 'styled-components';
import { eventApi } from '../../../core/api/rtk-query/event.api';
import toast from 'react-hot-toast';

const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(13, 25, 41, 0.36);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const Modal = styled.div`
  width: 480px;
  max-width: calc(100% - 24px);
  background: #fff;
  border-radius: 16px;
  padding: 24px;
  display: grid;
  gap: 16px;
`;

const Title = styled.h2`
  margin: 0;
  font-size: 18px;
  color: #0b1221;
`;

const Text = styled.p`
  margin: 0;
  color: #667085;
  font-size: 14px;
`;

const Row = styled.div`
  display: flex;
  gap: 8px;
  justify-content: flex-end;
`;

const Btn = styled.button`
  padding: 10px 20px;
  border-radius: 10px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;
  background: #fff;
  border: 1px solid #dbe3f6;
  color: #0b1221;
  &:hover:not(:disabled) {
    background: #f7f9ff;
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const DangerBtn = styled(Btn)`
  background: #d32f2f;
  color: #fff;
  border: none;
  &:hover:not(:disabled) {
    background: #b71c1c;
  }
`;

interface DeleteEventConfirmProps {
  eventId: string;
  onClose: () => void;
}

export const DeleteEventConfirm = ({ eventId, onClose }: DeleteEventConfirmProps) => {
  const [removeEvent, { isLoading }] = eventApi.useRemoveEventMutation();

  const handleDelete = async () => {
    try {
      await removeEvent({ id: eventId }).unwrap();
      toast.success('Мероприятие удалено');
      onClose();
    } catch (error: any) {
      toast.error(error?.data?.message || 'Ошибка при удалении');
    }
  };

  return (
    <Backdrop onClick={onClose}>
      <Modal onClick={e => e.stopPropagation()}>
        <Title>Удалить мероприятие?</Title>
        <Text>
          Это действие нельзя отменить. Все данные о попытках студентов будут потеряны.
        </Text>
        <Row>
          <Btn onClick={onClose}>Отмена</Btn>
          <DangerBtn onClick={handleDelete} disabled={isLoading}>
            {isLoading ? 'Удаление...' : 'Удалить'}
          </DangerBtn>
        </Row>
      </Modal>
    </Backdrop>
  );
};
